import React from "react";
import { Page } from "../../components/page/page";
import styles from "./nature.module.css";
import { ChooseButton } from "../../components/choose-button/choose-button";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setNature } from "../../store/stateSlice";

const options = [
  {
    value: "I feel at peace and connected to the earth",
    icon: "🤩",
  },
  {
    value: "I enjoy it, but there’s no strong connection",
    icon: "😌",
  },
  {
    value: "I prefer urban environments",
    icon: "🙂",
  },
  {
    value: "Not sure",
    icon: "🤔",
  },
];

const NaturePage = () => {
  const dispatch = useDispatch();
  return (
    <Page
      title="What is your connection to nature?"
      hideContinueButton={true}
      currentStep={6}
    >
      <ul className={styles.list}>
        {options.map((option, i) => (
          <li key={i}>
            <Link
              to="../animals"
              onClick={() => dispatch(setNature(option.value))}
            >
              <ChooseButton icon={option.icon}>{option.value}</ChooseButton>
            </Link>
          </li>
        ))}
      </ul>
    </Page>
  );
};

export { NaturePage };
